<style lang="less"></style>
<template>
  <div>
    <Layout class="app-frame" :siderCollapsed="siderCollapsed" :siderFixed="layoutConfig.siderFixed">
      <Sider :theme="layoutConfig.siderTheme">
        <appMenu :theme="layoutConfig.siderTheme"></appMenu>
      </Sider>
      <Layout :headerFixed="layoutConfig.headerFixed">
        <HHeader theme="white">
          <appHead @openSetting="openSetting = true" :layoutConfig="layoutConfig"></appHead>
        </HHeader>
        <SysTabs v-if="layoutConfig.showSystab" homePage="SettlementProcess"></SysTabs>
        <Content>
          <div class="app-frame-content">
            <router-view :key="$route.fullPath"></router-view>
          </div>
          <HFooter>
            <appFooter></appFooter>
          </HFooter>
        </Content>
      </Layout>
    </Layout>
    <Modal v-model="openSetting" type="drawer-right" title="系统布局配置">
      <appLayoutSetting :initLayoutConfig="layoutConfig"></appLayoutSetting>
    </Modal>
  </div>
</template>
<script>
import appLayoutSetting from './modules/app-layout-setting';
import appHead from './app-header';
import appMenu from './app-menu';
import appFooter from './app-footer';
import SysTabs from '../common/sys-tabs';
import { isAuthPage, filterMenuKeys, resolveMenuKeys, menuKeysEqual } from '@js/config/menu-config';
import Request from '@common/request';
import utils from '@common/utils';
import { mapState } from 'vuex';
import { heyuiConfig } from 'heyui';

const MENU_CACHE_KEY = 'SYS_USER_MENUS';

export default {
  data() {
    return {
      openSetting: false,
      layoutConfig: {
        siderTheme: 'white',
        showSystab: true,
        headerFixed: true,
        siderFixed: true
      }
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      Promise.all([
        Request.User.info(),
        Request.Dict.get(),
        Request.Account.menus(),
      ]).then(([userResp, dictResp, menuResp]) => {
        if (userResp.ok) {
          userResp.body.avatar = require('../../images/avatar.png');
          this.$store.dispatch('updateAccount', userResp.body);
        }
        if (dictResp.ok) {
          const dicts = dictResp.body;
          for (const dict of dicts) {
            heyuiConfig.addDict(dict.name, dict.data);
          }
        }
        if (menuResp.ok && menuResp.body && Array.isArray(menuResp.body.menus)) {
          const menuKeys = filterMenuKeys(menuResp.body.menus);
          this.applyMenuKeys(menuKeys);
        }
      }).catch(() => {});
    },
    applyMenuKeys(menuKeys) {
      if (menuKeysEqual(this.$store.state.menuKeys, menuKeys)) {
        return;
      }
      this.$store.dispatch('updateMenuKeys', menuKeys);
      utils.saveLocal(MENU_CACHE_KEY, menuKeys);
      if (!isAuthPage(menuKeys, this.$route.name)) {
        this.$router.replace({ name: 'PermissionError' });
      }
    },
    updateLayoutConfig({ key, value }) {
      this.layoutConfig[key] = value;
    },
    refreshMenus() {
      return Request.Account.menus().then((resp) => {
        if (resp.ok && resp.body && Array.isArray(resp.body.menus)) {
          const menuKeys = filterMenuKeys(resp.body.menus);
          this.applyMenuKeys(menuKeys);
          return menuKeys;
        }
        const storedKeys = utils.getLocal2Json(MENU_CACHE_KEY);
        const menuKeys = resolveMenuKeys(storedKeys);
        this.applyMenuKeys(menuKeys);
        return menuKeys;
      }).catch(() => []);
    }
  },
  computed: {
    siderCollapsed() {
      return this.$store.state.siderCollapsed;
    },
    ...mapState(['menus'])
  },
  components: {
    appHead,
    appMenu,
    SysTabs,
    appFooter,
    appLayoutSetting
  }
};
</script>
